import axios from '../util/axiosConfig';
import { getErrorMessage } from '../util/ErrorUtils';

export const getVisitsSubmittedForTypingAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1
    };
    return await axios.post(`/api/v1/typist/visits-submitted-for-typing`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false, error: null };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getTypistWorkloadListAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1
    };
    return await axios.post(`/api/v1/typist/workload-list`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false, error: null };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getDictationByReportIdAPI = async (reportId) => {
    return await axios.get(`/api/v1/dictation-report`, {
        params: {
            reportId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, dictation: response.data };
            } else {
                return { success: false, error: null };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getRadiologistTemplatesAPI = async (radiologistCode) => {
    return await axios.get(`/api/v1/typist/radiologist-templates`, {
        params: {
            radiologistCode
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, radiologistTemplates: response.data };
            } else {
                return { success: false, error: null };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const updateDictationReportAPI = async (dictationReport) => {
    return await axios.post(`/api/v1/typist/update-typist-report`, dictationReport)
        .then(function (response) {
            if (response.data) {
                return { success: true, visit: response.data };
            } else {
                return { success: false, error: null };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getTypParkedAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1
    };
    return await axios.post(`/api/v1/typist/parked`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false, error: null };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getTypSubmittedForVerificationAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1
    };
    return await axios.post(`/api/v1/typist/submitted-for-verification`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false, error: null };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getForTypingAutoNextVisitAPI = async (data) => {
    return await axios.post(`/api/v1/typist/for-typing-auto-next-visit`, data)
        .then(function (response) {
            return { success: true, data: response.data };
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getTypistAutoNextParkedVisitAPI = async (data) => {
    return await axios.post(`/api/v1/typist/auto-next-parked-visit`, data)
        .then(function (response) {
            return { success: true, data: response.data };
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getVisitReportAPI = async (risId, reportId, visitNo) => {
    return await axios.get(`/api/v1/typist/visit-report`, {
        params: {
            risId,
            reportId,
            visitNo
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, visitReport: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const getPatientHistoryReportsAPI = async (patientId) => {
    return await axios.get(`/api/v1/mis/patient-history-reports`, {
        params: {
            patientId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, patientHistoryReports: response.data };
            } else {
                return { success: false, error: null };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

// export const getPrimeStudyInfoAPI = async (risId, reportId, visitNo) => {
//     return await axios.get(`/api/v1/typist/prime-study-info`, {
//         params: {
//             risId, 
//             reportId, 
//             visitNo
//         }
//     })
//         .then(function (response) {
//             if (response.data) {
//                 return { success: true, primeStudyInfo: response.data };
//             } else {
//                 return { success: false, error: null };
//             }
//         })
//         .catch(function (error) {
//             return { success: false, error: getErrorMessage(error) };
//         });
// }

export const getVisitAuditAPI = async (reportId) => {
    return await axios.get(`/api/v1/visit-audit`, {
        params: {
            reportId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false, error: null };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const unparkVisitAPI = async (orderNo) => {
    return await axios.post(`/api/v1/unpark-visit-for-typist`, { orderNo })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false, error: null };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}
export const resubmitVisitForReportingAPI = async (data) => {
    return await axios.put(`/api/v1/typist/resubmit-visit-for-reporting`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false, error: null };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const unlockVisitAPI = async (reportId) => {
    return await axios.get(`/api/v1/unlock-visit`, {
        params: {
            reportId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false, error: null };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const downloadDictationAPI = async (dictationId) => {
    return await axios.get(`/api/v1/download-dictation/${dictationId}`, {
        responseType: 'blob'
    })
        .then(function (response) {
            return { success: true, data: response.data };
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}
